export default "__VITE_ASSET__aUKJxQDY__"